import React from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";

type WriteTheTranslationProps = {
  item: {
    id: number;
    name: string;
  };
};

export const WriteTheTranslation: React.FC<WriteTheTranslationProps> = ({ item }) => {
  return (
    <ExerciseTypeContainer item={item as never} title1="Translation Exercise" exerciseNumber={item.id.toString()} hideVerifyButton>
      Escreva a tradução
    </ExerciseTypeContainer>
  );
};
